export default __webpack_public_path__ + "static/media/FiraSans-Medium.caa0db8a.woff";